module.exports = __webpack_public_path__ + "img/game-black.f0046af0.svg";